/* WEBKUL PAGE BUILDER 2026 — frontend behaviour (extracted verbatim; nav/mega/mobile blocks no-op safely without a header) */
/* Progressive enhancement: page renders complete without JS. */
(function(){
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var LENIS_NATIVE_SCROLL = ['_wkheader', 'contact-modal'];
  if (window.Lenis && !reduce){
    var lenis = new Lenis({
      duration:1.1,
      easing:function(t){return Math.min(1,1.001-Math.pow(2,-10*t));},
      prevent:function(node){
        return !!(node && node.id && LENIS_NATIVE_SCROLL.indexOf(node.id) !== -1);
      }
    });
    window.__lenis = lenis;
    (function raf(t){ lenis.raf(t); requestAnimationFrame(raf); })();
    document.documentElement.classList.add('lenis');
  }

  /* ---- Nav scroll state ---- */
  var nav = document.getElementById('nav');
  var onScroll = function(){ if(nav) nav.classList.toggle('is-scrolled', window.scrollY > 8); };
  onScroll(); addEventListener('scroll', onScroll, {passive:true});

  /* ---- Mega menu ---- */
  var mega = document.getElementById('mega');
  var megaCard = document.getElementById('megaCard');
  var tops = [].slice.call(document.querySelectorAll('.nav-top[data-mega]'));
  var panels = {};
  document.querySelectorAll('.mega-panel').forEach(function(p){ panels[p.getAttribute('data-panel')] = p; });
  var closeTimer;
  function sizeCard(panel){ if(megaCard && panel) megaCard.style.height = panel.offsetHeight + 'px'; }
  function openMega(key){
    if(!mega || !panels[key]) return;
    clearTimeout(closeTimer);
    tops.forEach(function(b){ var on = b.getAttribute('data-mega')===key; b.classList.toggle('open',on); b.setAttribute('aria-expanded',on); });
    for(var k in panels){ panels[k].classList.toggle('active', k===key); }
    mega.classList.add('open'); sizeCard(panels[key]);
  }
  function closeMega(){ if(!mega) return; mega.classList.remove('open'); tops.forEach(function(b){ b.classList.remove('open'); b.setAttribute('aria-expanded','false'); }); }
  function scheduleClose(){ clearTimeout(closeTimer); closeTimer=setTimeout(closeMega,140); }
  tops.forEach(function(btn){
    var key = btn.getAttribute('data-mega');
    btn.addEventListener('mouseenter', function(){ openMega(key); });
    btn.addEventListener('focus', function(){ openMega(key); });
    btn.addEventListener('click', function(e){ e.preventDefault(); (mega.classList.contains('open') && btn.classList.contains('open')) ? closeMega() : openMega(key); });
    btn.addEventListener('mouseleave', scheduleClose);
  });
  if(mega){ mega.addEventListener('mouseenter', function(){ clearTimeout(closeTimer); }); mega.addEventListener('mouseleave', scheduleClose); }
  document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeMega(); });
  addEventListener('resize', function(){ if(mega && mega.classList.contains('open')) sizeCard(document.querySelector('.mega-panel.active')); });
  document.querySelectorAll('.mega-panel').forEach(function(panel){
    var railBtns = [].slice.call(panel.querySelectorAll('.mm-rail button[data-plat]'));
    var subs = [].slice.call(panel.querySelectorAll('.mm-subpanel[data-plat]'));
    function activate(plat){
      railBtns.forEach(function(b){ b.classList.toggle('active', b.getAttribute('data-plat')===plat); });
      subs.forEach(function(s){ s.classList.toggle('active', s.getAttribute('data-plat')===plat); });
      if(mega && mega.classList.contains('open')) sizeCard(panel);
    }
    railBtns.forEach(function(rb){ rb.addEventListener('mouseenter', function(){ activate(rb.getAttribute('data-plat')); }); rb.addEventListener('click', function(){ activate(rb.getAttribute('data-plat')); }); });
    var more = panel.querySelector('.mm-rail-more'), extra = panel.querySelector('.mm-rail-extra');
    if(more && extra){ more.addEventListener('click', function(){ var open=extra.classList.toggle('open'); more.setAttribute('aria-expanded',open); more.textContent=open?'View Less':'View All'; if(mega&&mega.classList.contains('open')) sizeCard(panel); }); }
  });

  /* ---- Mobile menu ---- */
  var toggle = document.querySelector('.nav-toggle'), menu = document.getElementById('mobileMenu'), menuClose = document.getElementById('menuClose');
  function setMenu(open){ if(!menu) return; menu.classList.toggle('open',open); if(menuClose) menuClose.classList.toggle('open',open); if(toggle) toggle.setAttribute('aria-expanded',open); document.body.style.overflow = open?'hidden':''; }
  if(toggle) toggle.addEventListener('click', function(){ setMenu(!menu.classList.contains('open')); });
  if(menuClose) menuClose.addEventListener('click', function(){ setMenu(false); });
  if(menu){
    menu.querySelectorAll('a').forEach(function(a){ a.addEventListener('click', function(){ setMenu(false); }); });
    menu.querySelectorAll('.mob-top').forEach(function(b){ b.addEventListener('click', function(){ var g=b.parentElement, open=g.classList.toggle('open'); b.setAttribute('aria-expanded',open); }); });
  }

  /* ---- Services category tabs ----
     Wired per section, not per page: `.tab` and `.tabpanel` were collected with
     one document-wide query, so two Services sections on the same page shared a
     tab bar — clicking a tab in one blanked the other. Each `.svc-tabs-head`
     now owns its own bar and panels.

     Panels are paired to bar buttons by the `data-tab` / `data-panel` key, and
     by POSITION when the keys cannot settle it: an author who adds a tab
     through the block inserter gets an empty key, and a duplicated tab carries
     its twin's. Either way the key match found no panel — or the wrong one — and
     the section opened with no cards in it. */
  [].slice.call(document.querySelectorAll('.svc-tabs-head')).forEach(function(head){
    var bar = head.querySelector('.tabbar');
    var wrap = head.querySelector('.tabwrap');
    if(!bar || !wrap){ return; }

    var tabs = [].slice.call(bar.querySelectorAll('.tab'));
    var panels = [].slice.call(wrap.querySelectorAll('.tabpanel'));
    if(!tabs.length || !panels.length){ return; }

    /* A key is only usable when it is set on both sides and unambiguous. */
    function keyed(list, attr){
      var seen = {};
      for(var i = 0; i < list.length; i++){
        var k = list[i].getAttribute(attr);
        if(!k || seen[k]){ return null; }
        seen[k] = true;
      }
      return seen;
    }
    var tabKeys = keyed(tabs, 'data-tab');
    var panelKeys = keyed(panels, 'data-panel');
    var byKey = !!(tabKeys && panelKeys);

    function panelFor(tab, i){
      if(byKey){
        for(var j = 0; j < panels.length; j++){
          if(panels[j].getAttribute('data-panel') === tab.getAttribute('data-tab')){ return panels[j]; }
        }
      }
      return panels[i] || null;
    }

    function open(tab, i){
      var panel = panelFor(tab, i);
      /* Never leave the section empty: a tab with no panel of its own keeps
         whatever is showing rather than hiding everything. */
      if(!panel){ return; }
      tabs.forEach(function(t){ var on = t === tab; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
      panels.forEach(function(p){ p.classList.toggle('is-active', p === panel); });
      reveal(tab);
    }

    /* The bar scrolls sideways once the tabs outgrow it: bring a tab that is
       cut off at either edge fully into view, without moving the page. */
    function reveal(tab){
      if(bar.scrollWidth <= bar.clientWidth){ return; }
      var left = tab.offsetLeft - bar.offsetLeft, right = left + tab.offsetWidth;
      if(left < bar.scrollLeft){ bar.scrollLeft = Math.max(0, left - 16); }
      else if(right > bar.scrollLeft + bar.clientWidth){ bar.scrollLeft = right - bar.clientWidth + 16; }
    }

    /* Panels built from wkpageb/services-tab child blocks carry no .is-active of
       their own (a child block has no index), so the first one is opened here
       and the wrap is marked .is-ready — which retires the CSS fallback that was
       showing it. */
    var active = panels.filter(function(p){ return p.classList.contains('is-active'); })[0];
    if(!active){
      var first = tabs.filter(function(t){ return t.classList.contains('is-active'); })[0] || tabs[0];
      open(first, tabs.indexOf(first));
    }
    wrap.classList.add('is-ready');

    tabs.forEach(function(tab, i){
      tab.addEventListener('click', function(){
        open(tab, i);
        /* keep the tapped tab centred in the mobile scroll strip */
        if(window.matchMedia('(max-width:640px)').matches && tab.scrollIntoView){
          tab.scrollIntoView({inline:'center', block:'nearest', behavior:'smooth'});
        }
      });
    });
  });

  /* ---- Count-up stats ---- */
  function formatNum(n){ return n>=1000 ? n.toLocaleString('en-US') : String(n); }
  function countUp(el){
    var to = parseInt(el.getAttribute('data-to'),10) || 0;
    var suffix = el.getAttribute('data-suffix') || '';
    if(reduce){ el.textContent = formatNum(to)+suffix; return; }
    var dur = 1400, start = null;
    function step(ts){
      if(!start) start = ts;
      var p = Math.min(1, (ts-start)/dur);
      var eased = 1 - Math.pow(1-p, 3);
      el.textContent = formatNum(Math.round(to*eased)) + suffix;
      if(p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ---- Reveal + counters via one observer (the process line has its own block below) ---- */
  var counted = false;
  if(!('IntersectionObserver' in window) || reduce){
    document.querySelectorAll('[data-rv]').forEach(function(el){ el.classList.add('in'); });
    document.querySelectorAll('.count').forEach(countUp);
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(!e.isIntersecting) return;
        /* Elements taller than the viewport can never reach the .16 ratio
           (e.g. the stacked tech grid on mobile) — reveal them on first entry. */
        if(e.intersectionRatio < .16 && e.boundingClientRect.height <= innerHeight) return;
        e.target.classList.add('in');
        if(e.target.classList.contains('svc-stats') && !counted){ counted = true; e.target.querySelectorAll('.count').forEach(countUp); }
        io.unobserve(e.target);
      });
    }, {threshold:[0,.16], rootMargin:'0px 0px -6% 0px'});
    document.querySelectorAll('[data-rv]').forEach(function(el){ io.observe(el); });
  }
})();

/* ---- Delivery process: light steps + grow the line with scroll ----
   Its own IIFE so nothing above can stop it. State is computed from where the
   section sits RIGHT NOW, not from how far the reader has scrolled since load,
   so a refresh half-way down the page (the browser restores the scroll after
   this runs), a late font/image reflow, a back/forward-cache restore or a Lenis
   smooth scroll all land on the right step without the reader having to move. */
(function(){
  var procs = [].slice.call(document.querySelectorAll('.proc'));
  if(!procs.length) return;

  var reduce = false;
  try{ reduce = matchMedia('(prefers-reduced-motion:reduce)').matches; }catch(e){}

  var items = procs.map(function(proc){
    return { el: proc, steps: [].slice.call(proc.querySelectorAll('.pstep')), line: proc.querySelector('.proc-line'), fill: proc.querySelector('.proc-line i') };
  });

  /* End the track at the centre of the last step's node, so no line runs on
     past the final step — whatever the number of steps. */
  function fitLine(item){
    if(!item.line || !item.steps.length) return;
    var last = item.steps[item.steps.length - 1].querySelector('.node');
    if(!last) return;
    var box = item.el.getBoundingClientRect(), n = last.getBoundingClientRect();
    if(!n.width) return; // hidden (mobile layout hides the track anyway)
    item.line.style.right = Math.max(0, box.right - (n.left + n.width / 2)) + 'px';
  }

  function paint(item, prog){
    if(item.fill) item.fill.style.width = (prog*100).toFixed(1) + '%';
    var lit = Math.round(prog * item.steps.length);
    item.steps.forEach(function(s,i){ s.classList.toggle('on', i < Math.max(1,lit)); });
  }

  /* Reduced motion: show the finished timeline, no scroll tracking. */
  if(reduce){ items.forEach(function(item){ paint(item, 1); }); return; }

  function update(){
    var vh = window.innerHeight || document.documentElement.clientHeight;
    items.forEach(function(item){
      fitLine(item);
      var r = item.el.getBoundingClientRect();
      var prog = (vh*0.82 - r.top) / (r.height + vh*0.5);
      paint(item, Math.max(0, Math.min(1, prog)));
    });
  }

  var queued = false;
  function tick(){
    if(queued) return;
    queued = true;
    requestAnimationFrame(function(){ queued = false; update(); });
  }

  update();
  addEventListener('scroll', tick, {passive:true});
  addEventListener('resize', tick);
  addEventListener('load', function(){ update(); setTimeout(update, 120); });
  addEventListener('pageshow', tick);
  if(window.__lenis && window.__lenis.on) window.__lenis.on('scroll', tick);
  if(window.ResizeObserver){
    var ro = new ResizeObserver(tick);
    items.forEach(function(item){ ro.observe(item.el); });
  }
  if(document.fonts && document.fonts.ready) document.fonts.ready.then(tick);
})();

(function(){
  var root = document.getElementById('technologies'); if(!root) return;
  var tiles = [].slice.call(root.querySelectorAll('.integ-tile'));
  var cats  = [].slice.call(root.querySelectorAll('.integ-cat'));
  var searches = [].slice.call(root.querySelectorAll('.integ-search'));
  var select = root.querySelector('.integ-select');
  var empty = root.querySelector('.integ-empty');
  var state = {cat:'All', q:''};
  function decode(s){ return (s||'').replace(/&amp;/g,'&'); }
  function apply(){
    var q = state.q.trim().toLowerCase(), cat = state.cat, shown = 0;
    tiles.forEach(function(t){
      var tc = decode(t.getAttribute('data-cat'));
      var okCat = cat === 'All' || tc === cat;
      var okQ = !q || (t.getAttribute('data-name')||'').indexOf(q) > -1 || t.textContent.toLowerCase().indexOf(q) > -1;
      var show = okCat && okQ;
      t.hidden = !show; if(show) shown++;
    });
    if(empty) empty.style.display = shown ? 'none' : 'block';
    cats.forEach(function(c){ c.classList.toggle('on', decode(c.getAttribute('data-cat')) === cat); });
    if(select) select.value = cat;
  }
  function scrollToStart(){
    var mod = root.querySelector('.integ-mod') || root;
    var y = mod.getBoundingClientRect().top + window.pageYOffset - 100;
    if(y >= window.pageYOffset - 4) return; /* already at/above the grid start — don't yank down */
    if(window.__lenis && window.__lenis.scrollTo){ window.__lenis.scrollTo(y, {duration:0.8}); }
    else { try{ window.scrollTo({top:y, behavior:'smooth'}); }catch(e){ window.scrollTo(0,y); } }
  }
  cats.forEach(function(c){ c.addEventListener('click', function(){ state.cat = decode(c.getAttribute('data-cat')); apply(); scrollToStart(); }); });
  if(select) select.addEventListener('change', function(){ state.cat = select.value; apply(); scrollToStart(); });
  searches.forEach(function(inp){ inp.addEventListener('input', function(){ state.q = inp.value; searches.forEach(function(o){ if(o!==inp) o.value = inp.value; }); apply(); }); });
  /* hide any logo that fails to load so tiles never show a broken image */
  tiles.forEach(function(t){ var img = t.querySelector('img'); if(img) img.addEventListener('error', function(){ img.style.visibility='hidden'; }); });
})();

(function(){
  function initBpFlow(){
    if(!window.gsap) return;
    try{ if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; }catch(e){}
    var g1=document.getElementById('paint1_linear_4164_49528'); // top-right connector
    var g2=document.getElementById('paint2_linear_4164_49528'); // left connector
    if(g1){
      gsap.fromTo(g1,{attr:{y1:820,y2:713}},
        {attr:{y1:-60,y2:-167},duration:2.8,ease:'none',repeat:-1});
    }
    if(g2){
      gsap.fromTo(g2,{attr:{y1:-160,y2:-62}},
        {attr:{y1:1400,y2:1498},duration:3.6,ease:'none',repeat:-1,delay:-1.4});
    }
  }
  if(document.readyState!=='loading') initBpFlow();
  else document.addEventListener('DOMContentLoaded', initBpFlow);
})();

/* ---- Customer stories: sticky-stack depth ----
   The rows pin with pure CSS (position:sticky, see #customers .story). This
   supplies the two things the stylesheet cannot work out on its own:
     1. `--i`, the row's index — the rows are author-managed child blocks, so
        the CSS has no way to stagger their pin offsets by itself. Without it
        every card pins at the same 96px and covers the one beneath it edge to
        edge, which is why the stack was invisible.
     2. the depth pass — each card scales down and dims as the next one rides
        up over it, so the cards underneath read as a stack rather than as a
        stray border.
   Desktop only, and skipped entirely under prefers-reduced-motion: both
   mirror the media queries the sticky rule itself is scoped to. */
(function(){
  'use strict';
  var reduce = matchMedia('(prefers-reduced-motion:reduce)').matches;
  var wrap = document.querySelector('[data-stories]');
  if(!wrap) return;
  var cards = [].slice.call(wrap.querySelectorAll('.story'));
  if(cards.length < 2) return;

  cards.forEach(function(card, i){ card.style.setProperty('--i', i); });

  var wide = matchMedia('(min-width:960px)');
  var queued = 0;

  function paint(){
    queued = 0;
    for(var i = 0; i < cards.length; i++){
      var card = cards[i], next = cards[i + 1];
      /* The last card is never covered, and below 960px / under reduced
         motion the rows are a plain column — nothing to shade. */
      if(!next || reduce || !wide.matches){
        card.style.transform = '';
        card.style.setProperty('--cover', 0);
        continue;
      }
      var box = card.getBoundingClientRect();
      /* 0 while the next card is still clear of this one, 1 once it has
         ridden all the way up over it. */
      var p = box.height ? (box.bottom - next.getBoundingClientRect().top) / box.height : 0;
      p = p < 0 ? 0 : (p > 1 ? 1 : p);
      card.style.transform = 'scale(' + (1 - p * 0.04).toFixed(4) + ')';
      /* Dimming rides on --cover, which CSS paints as an opaque overlay. The
         card itself must stay fully opaque: it has other cards stacked behind
         it, and any translucency lets them show through. */
      card.style.setProperty('--cover', p.toFixed(3));
    }
  }

  function onScroll(){ if(!queued) queued = requestAnimationFrame(paint); }

  paint();
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll);
})();
